import { useState } from 'react'
import type { Overview } from '@manaro/contracts'
import { Card } from '@/shared/ui/card.tsx'
import { cn } from '@/shared/lib/cn.ts'
import { plural } from '@/shared/lib/format.ts'

export function SalonsChart({ chart }: { chart: Overview['chart'] }) {
  const [hovered, setHovered] = useState<number | null>(null)
  const max = Math.max(...chart.bars.map((bar) => bar.value), 1)
  const active = hovered !== null ? chart.bars[hovered] : undefined

  return (
    <Card className="flex min-w-0 flex-col px-5.5 pt-5 pb-4.5">
      <div className="mb-4.5 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-display text-[17px] font-semibold">{chart.title}</h2>
        <span className="text-[13.5px] text-ink-soft">
          {active ? `${active.label} — ${active.value} ${plural(active.value, ['салон', 'салона', 'салонов'])}` : chart.unit}
        </span>
      </div>

      <div className="flex min-h-[132px] flex-1 items-stretch gap-1.5" onMouseLeave={() => setHovered(null)}>
        {chart.bars.map((bar, index) => (
          <button
            key={`${bar.label}-${index}`}
            type="button"
            onMouseEnter={() => setHovered(index)}
            onFocus={() => setHovered(index)}
            aria-label={`${bar.label}: ${bar.value} ${plural(bar.value, ['салон', 'салона', 'салонов'])}`}
            className="flex min-w-0 flex-1 flex-col gap-2"
          >
            <span className="flex min-h-0 flex-1 items-end">
              <span
                className={cn(
                  'block flex-1 shrink-0 rounded-t-[5px] rounded-b-[3px] transition-[height,background-color] duration-300',
                  index === hovered ? 'bg-brand' : 'bg-brand-soft',
                )}
                style={{ height: `${Math.max(3, Math.round((bar.value / max) * 100))}%` }}
              />
            </span>
            <span className="truncate text-[11.5px] text-ink-muted">{bar.label}</span>
          </button>
        ))}
      </div>
    </Card>
  )
}
